import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/solicitacao/licenca';

const licenseEndpoints = {
    getFixedGroups: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/tipogrupofixo`),
    getLicenseChangeTypes: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/tipoalteracaolicenca/find-all`),
    saveRequest: (payload, context = EXTERNAL_CONTEXT) => stipAxios.post(`${context}${BASE_ENDPOINT}/save`, payload),
    finishRequest: (cdSolicitacao) =>
        stipAxios.put(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/finalizar/${cdSolicitacao}`, {}),
    cancelRequest: (cdSolicitacao, payload = {}, context = EXTERNAL_CONTEXT) =>
        stipAxios.put(`${context}${BASE_ENDPOINT}/cancelar/${cdSolicitacao}`, payload),
    getLicenseByRequest: (cdSolicitacao) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/solicitacao/${cdSolicitacao}`),
    getLicenses: (params, context = EXTERNAL_CONTEXT) => {
        const { page, size, request } = params;
        return stipAxios.post(`${context}${BASE_ENDPOINT}/pages/${page}/${size ? size : 10}`, request);
    },
    getNewLicenseDuplicate: (payload) => {
        return stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/segunda-via/new`, payload);
    },
    checkLicenseInProgress: (cdLicencaOrigem) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/is-segunda-via-andamento/${cdLicencaOrigem}`),
    deleteVehicle: (cdLicencaVeiculo, cdSolicitacao) =>
        stipAxios.delete(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/veiculo/excluir/${cdLicencaVeiculo}/${cdSolicitacao}`),
};

export default licenseEndpoints;
